'use client';

import { Box, Button, Container, Image } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import { MainPageHeader } from 'components/main-page-header/main-page-header';
import { useLocale } from 'next-intl';
import css from './header.module.css';
function Header() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'karma');
  return <Container data-sentry-element="Container" data-sentry-component="Header" data-sentry-source-file="header.tsx">
            <MainPageHeader title={t('intro.title')} subtitle={t('intro.description')} buttonRow={[<Button key="1" size="large" href="/app/settings/productivity">
                        {t('intro.cta')}
                    </Button>]} data-sentry-element="MainPageHeader" data-sentry-source-file="header.tsx" />
            <Box className={css.imageWrapper} data-sentry-element="Box" data-sentry-source-file="header.tsx">
                <Image src={`${process.env.NEXT_PUBLIC_BASE_URL}/static/karma/header-illus.png`} priority width={776} height={446} alt="" data-sentry-element="Image" data-sentry-source-file="header.tsx" />
            </Box>
        </Container>;
}
export { Header };